export default "__VITE_ASSET__DgUBREv2__"